import React, { useEffect, useState, useRef, useCallback } from "react"
import './discover.css';
import { handleBookingStatus } from './discover-services.js';
import DiscoverModal from "../../components/Modals/discoverModal";

import { ReactComponent as ArrowPrevIcon } from "../../assets/svg/arrow-previous.svg";
import { ReactComponent as ArrowNextIcon } from "../../assets/svg/arrow-next.svg";
import { ReactComponent as MeetQIcon } from "../../assets/svg/meetq-logo.svg";
import { ReactComponent as ScanIcon } from "../../assets/svg/scan.svg";
import { ReactComponent as ArrowDownIcon } from "../../assets/svg/arrow-down.svg";
import { ReactComponent as SlotFilterIcon } from "../../assets/svg/filter-search.svg";
import { ReactComponent as SlotCloseIcon } from "../../assets/svg/close-1.svg";
import { ReactComponent as FilterCloseIcon } from "../../assets/svg/close-filter.svg";
import { ReactComponent as CalendarIcon } from "../../assets/svg/calendar-outline.svg";
import { ReactComponent as FilterIcon } from "../../assets/svg/filter-icon.svg";
import { ReactComponent as FilterCloseMobileIcon } from "../../assets/svg/close-1.svg";
import RoomImage from "../../assets/png/room-image.png";
import SearchWithAPI from "../searchbox/searchbox";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import { format, parse } from 'date-fns';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import Header from "../common/Header";
import { getCookie } from '../getcookie.js';
import { BottomSheet } from 'react-spring-bottom-sheet'
import "react-spring-bottom-sheet/dist/style.css";
import { Form, Button, InputGroup } from "react-bootstrap";
import { ReactComponent as SearchIcon } from "../../assets/svg/search.svg";
import LoaderModal from "../common/Loader.js";
import { ReactComponent as NoRecordsFound } from "../../assets/svg/no-records-found.svg";
import RepeatBookingModal from "../Modals/repeatBookingModal.js";
import { Toast, ToastContainer } from "react-bootstrap";
import moment from "moment";
import { useGlobal } from "../../GlobalContext.js";

export default function DiscoverBootStrap() {
  const { selectedMenu, setSelectedMenu } = useGlobal();
  const apiUrl = process.env.REACT_APP_API_URL;
  const [showModal, setShowModal] = useState(false);
  const [DetialId, setDetialId] = useState(-1);
  const [showRepeatBookingModal, setShowRepeatBookingModal] = useState(false);
  console.log('apiUrl.........', apiUrl);
  const today = new Date();
  const navigate = useNavigate();

  const handleReset = async () => {
    setSelectedOfficeOption(null);
    setOfficeValue('');
    setFloorValue('');
    setSelectedDate(moment(today).format("YYYY-MM-DD"));
    setFloors([]);


  };

  const scrollRefs = useRef([]);

  const scrollLeft = (index) => {
    const ref = scrollRefs.current[index];
    if (ref) {
      ref.scrollBy({ left: -100, behavior: "smooth" });
    }
  };

  const scrollRight = (index) => {
    const ref = scrollRefs.current[index];
    if (ref) {
      ref.scrollBy({ left: 100, behavior: "smooth" });
    }
  };

  const [selectedOffice, setOfficeValue] = useState('');
  const [selectedFloor, setFloorValue] = useState('');
  const handleDropdownChange = (option) => {
    setSelectedOfficeOption(option)
    setOfficeValue(option.value);

    console.log('fetchOptions called from handleDropdownChange')

  };


  const [selectedDate, setSelectedDate] = useState(moment(today).format("YYYY-MM-DD"));
  const [selectedDateFormat, setSelectedDateFormat] = useState('');


  const [selectedCategory, setCategoryValue] = useState('');
  const [selectedSlot, setSlotValue] = useState('30 mins');
  const [selectedBookId, setBookId] = useState([]);
  const [bookIdList, setBookIdList] = useState([]);
  const [categoryList, setCategory] = useState([]);

  const [floorList, setFloors] = useState([]);
  const [roomList, setRooms] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const openModal = (id, index) => {
    setRoomIndex(index);
    setRoomId(id);
    setIsOpen(true);
  };
  const closeModal = () => setIsOpen(false);
  const [selectedRoomId, setRoomId] = useState(-1);
  const [selectedRoomIndex, setRoomIndex] = useState(-1);
  const [openFilter, setOpenFilter] = useState(false);
  const [searchInputValue, setSearchInputValue] = useState("");
  const [alertIndex, setAlertIndex] = useState(null);
  const [selectedOfficeOption, setSelectedOfficeOption] = useState(null);
  const alertRef = useRef(null);
  const handleClickOutside = (event) => {
    if (alertRef.current && !alertRef.current.contains(event.target)) {
      setAlertIndex(null); // Close the alert
    }
  };
  const menuBoxInactive = { width: '128px', height: '44px', display: 'flex', justifyContent: "center", alignItems: "center", };
  const menuBoxActive = { width: '128px', height: '44px', display: 'flex', justifyContent: "center", alignItems: "center", borderBottom: "3px solid #842234", };
  const menuColorActive = { fontSize: "15px", fontWeight: "700", lineHeight: "17.17px", color: '#842234', };
  const menuColorInactive = { fontSize: "15px", fontWeight: "400", lineHeight: "17.17px", color: '#1E1E1E', };
  const profileName = { fontSize: "14px", fontWeight: "700", color: '#842234', };
  const title = { fontSize: "32px", fontWeight: "700", color: '#1E1E1E', };
  const subtitle = { fontSize: "15px", fontWeight: "400", color: '#81878C', };
  const roomTitle = { fontSize: "18px", fontWeight: "500", color: '#1E1E1E', };
  const seatCount = { fontSize: "13.5px", fontWeight: "400", color: '#81878C', marginTop: '8px', };
  const availableTitle = { fontSize: "12px", fontWeight: "400", color: '#81878C', marginBottom: '8px', };
  const availableName = { fontSize: "12.5px", fontWeight: "400", color: '#21272C' };
  const slotTitle = { fontSize: "13px", fontWeight: "700", color: '#1E1E1E' };
  const slotTitleSelected = { fontSize: "12px", fontWeight: "500", color: '#842234' };
  const filterTitle = { fontSize: "24px", fontWeight: "700", color: '#1E1E1E' };
  const officeTitle = { marginTop: '16px', marginBottom: '8px', fontSize: "15px", fontWeight: "700", lineHeight: "17.17px", color: '#1E1E1E', };
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.1)",
      opacity: 0.8,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "16px 24px",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0)",
      width: "328px",
      height: "229px",
      textAlign: "center",
    },
  };


  const handleCategoryClick = (category) => {
    setCategoryValue(category);

  };
  function commonFormatDate(inputDate, formatString) {
    try {
      if (inputDate !== undefined) {
        /* // Parse the input date (MM/DD/YYYY format)
        const parsedDate = parse(inputDate, "MM/dd/yyyy", new Date());
   
        // Format the date
        return format(parsedDate, "EEEE, dd MMM yyyy");"dddd, DD MMM YYYY" */
        return moment(moment(inputDate, "YYYY-MM-DD").toDate()).format(formatString)
      } else {
        return "";
      }
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
    }
  }
  function formatDate(inputDate) {
    try {
      if (inputDate !== undefined) {


        // Parse the input date (MM/DD/YYYY format)
        const parsedDate = parse(inputDate, 'MM/dd/yyyy', new Date());


        // Format the date
        return format(parsedDate, "EEEE, dd MMM yyyy");
      } else {
        return "";
      }
    } catch (err) {
      console.error("Error fetching options:", err);

    } finally {

    }
  }
  function formatDate2(inputDate) {
    console.log('current date time.....', inputDate);
    try {
      if (inputDate !== undefined) {
        // Parse the input date (MM/DD/YYYY format)
        const parsedDate = parse(inputDate, 'MM/dd/yyyy', new Date());


        // Format the date
        return format(parsedDate, "yyyy-MM-dd");
      } else {
        return "";
      }
    } catch (err) {
      console.error("Error fetching options:", err);

    } finally {

    }
  }
  useEffect(() => {
    setSelectedMenu("Discover");
    setSelectedDate(moment(today).format("YYYY-MM-DD"));
    setSelectedDateFormat(formatDate2(today.toLocaleDateString()));

    getCategory();
    getDefaultDetails();

  }, []);

  useEffect(() => {
    if (selectedOfficeOption != null) {
      getFloor(selectedOfficeOption.value)
    }

  }, [selectedOfficeOption]);

  useEffect(() => {
    if (selectedDate !== "") {

      console.log('fetchOptions called from useEffect selectedDateFormat')
      fetchOptions();

    }

  }, [selectedDate]);

  useEffect(() => {

    if (selectedOffice !== "") {
      console.log('fetchOptions called from useEffect selectedOffice')
      fetchOptions();
    }

  }, [selectedOffice, selectedFloor]);

  useEffect(() => {
    if (selectedOfficeOption === null && selectedOffice === "" && selectedFloor === "") {
      fetchOptions();
    }
  }, [selectedOfficeOption, selectedOffice, selectedFloor]);

  const getDefaultDetails = async () => {
    try {
      const response = await axios.get(apiUrl + "get_discover_default_filters", {
        params: {},
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          "Accept": "application/json",
          "Access-Control-Allow-Origin": "*", // Required for CORS support to work
          "Authorization": getCookie("mawalog")
        }
      }).then(async (response) => {
        if (response.data.success === true) {
          setSelectedOfficeOption({ 'value': response.data.filter.office_id, 'label': response.data.filter.office })
          setOfficeValue(String(response.data.filter.office_id))
          setFloorValue(String(response.data.filter.floor_value))
        }
      }).catch((error) => {
        if (error.response) {
          console.error("Error Status:", error.response.status);
          console.error("Error Data:", error.response.data);
          if (error.response.status === 400) {

          }
        }
      });

    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  useEffect(() => {

    if (selectedCategory !== "") {
      console.log('fetchOptions called from useEffect selectedCategory')
      fetchOptions();
    }


  }, [selectedCategory]);

  useEffect(() => {
    console.log('slot changed');
    if (selectedSlot !== 'custom') {
      getSlots();
    }
  }, [selectedSlot]);
  /* useEffect(() => {
    console.log('fetchOptions called from useEffect2')
    fetchOptions();
   
   
  },[ selectedCategory, selectedDate, selectedFloor]);  */
  const getSlots = async () => {

    console.log("get_slots api called");
    const data = {
      "office_id": selectedOffice,
      "floor": selectedFloor,
      "date": selectedDate,
      "from": "",
      "to": "",
      "id": [selectedRoomId],
      "range": selectedSlot
    };

    const headers = {
      'Content-Type': 'application/json;',
      "Accept": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Authorization": getCookie("mawalog")
    };
    const response = await axios.post(apiUrl + "get_slots",
      data,
      { headers: headers }
    ).then(async (response) => {
      if (response.statusCode === 400) {
      } else {
        if (response.data.success === true) {


          response.data.data.forEach((roomobj) => {
            /*  for (var roomobj in response2.data.data) { */

            const index = roomList
              .findIndex(element => element.id === roomobj["id"]);

            if (index > -1) {
              /*  meetingList[index]["slots"] = room["slots"]; */
              setRooms((prevRooms) => {
                const updatedArray = [...prevRooms];
                if (updatedArray[index] !== undefined) {
                  updatedArray[index]["slots"] = roomobj["slots"];

                }

                return updatedArray;

              });
            }
          });

          await new Promise((resolve) =>
            setTimeout(() => resolve(), 1000)
          );
          const today = new Date().toISOString().split('T')[0]; // "YYYY-MM-DD"
          const selected = new Date(selectedDate).toISOString().split('T')[0];
          console.log('date today', today);
          console.log('date selected', today);
          if (today === selected) {
            var slotIndex = -1;
            if (response.data.data.length > 0) {
              const now = new Date();
              const hours = now.getHours().toString().padStart(2, '0');
              const minutes = now.getMinutes().toString().padStart(2, '0');
              /* for (const [index, slot] of response2.data.data[0]["slots"]) {
                const isCurrentTime=  compareTimes(`${hours}:${minutes}`,slot["from"]); 
                if (isCurrentTime === true) {                              
                  break; // Exit the loop
                }
                
              } */
              response.data.data[0]["slots"].some((slot, index) => {
                console.log('current time.....', `${hours}:${minutes}`)
                console.log('slot time.....', slot["from"])
                const isCurrentTime = compareTimes(slot["from"], slot["to"], `${hours}:${minutes}`);
                console.log('isCurrentTime.....', isCurrentTime)
                if (isCurrentTime === true) {
                  slotIndex = index;
                  return true; // Exit the loop
                }
                return false;
              });

            }
            console.log('date equal');
            response.data.data.forEach(async (roomobj) => {
              /*  for (var roomobj in response2.data.data) { */

              const index = roomList
                .findIndex(element => element.id === roomobj["id"]);
              console.log(index);
              if (index > -1) {
                /*  meetingList[index]["slots"] = room["slots"]; */

                console.log('ref slotIndex', slotIndex)
                console.log('ref Index', index)
                const ref = scrollRefs.current[index];
                if (ref) {
                  console.log('ref exist')

                  ref.scrollTo({
                    left: 0,
                    behavior: 'smooth',
                  });
                  await new Promise((resolve) =>
                    setTimeout(() => resolve(), 500)
                  );
                  ref.scrollBy({ left: 126 * (slotIndex + 1), behavior: "smooth" });
                }

              }
            });
          }
        }
      }
    }).catch((error) => {

    });








  };




  const getCustomSlots = async (startTime, endTime) => {
    //  setCustomSlotErrorMessage({date:'',  from:'',  to:'',});
    try {
      console.log("get_slots api called");
      const data = {
        "room_id": roomList[selectedRoomIndex]["id"],
        "date": selectedDate,
        "from": startTime.slice(0, 5),
        "to": endTime.slice(0, 5),
        repeat_booking: false,
      };

      const headers = {
        'Content-Type': 'application/json;',
        "Accept": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Authorization": getCookie("mawalog")
      };
      const response = await axios.post(apiUrl + "check_slot_availability",
        data,
        { headers: headers }
      ).then((response) => {
        if (response.statusCode === 400) {
        } else {
          if (response.data.success === true) {
            if (response.data.available === true) {
              //setErrorMessage('');

              setRooms((prevRooms) => {
                const updatedArray = [...prevRooms];
                if (updatedArray[selectedRoomIndex] !== undefined) {
                  updatedArray[selectedRoomIndex]["error_message"] = '';
                  updatedArray[selectedRoomIndex]["selected_slot"] = roomList[selectedRoomIndex]["start_time_12hr"] + ' - ' + roomList[selectedRoomIndex]["end_time_12hr"];
                  updatedArray[selectedRoomIndex]["selected_slot_from"] = roomList[selectedRoomIndex]["start_time"].slice(0, 5);
                  updatedArray[selectedRoomIndex]["selected_slot_to"] = roomList[selectedRoomIndex]["end_time"].slice(0, 5);
                }
                return updatedArray;
              });
            } else {

              setRooms((prevRooms) => {
                const updatedArray = [...prevRooms];
                if (updatedArray[selectedRoomIndex] !== undefined) {
                  updatedArray[selectedRoomIndex]["error_message"] = 'Slot not available';
                  updatedArray[selectedRoomIndex]["selected_slot"] = '';
                  updatedArray[selectedRoomIndex]["selected_slot_from"] = '';
                  updatedArray[selectedRoomIndex]["selected_slot_to"] = '';
                }
                return updatedArray;
              });
            }
          }
        }
      }).catch((error) => {
        if (error.response) {
          console.error("Error Status:", error.response.status);
          console.error("Error Data:", error.response.data);
          if (error.response.status === 400) {
            var errorMsg = error.response.data.error;
            // setErrorValue(error.response.data.error);
            console.log('error msg', errorMsg)
            setRooms((prevRooms) => {
              const updatedArray = [...prevRooms];
              if (updatedArray[selectedRoomIndex] !== undefined) {
                console.log('before...', updatedArray[selectedRoomIndex]);
                updatedArray[selectedRoomIndex]["error_message"] = 'Slot not available';
                updatedArray[selectedRoomIndex]["selected_slot"] = '';
                updatedArray[selectedRoomIndex]["selected_slot_from"] = '';
                updatedArray[selectedRoomIndex]["selected_slot_to"] = '';
              }
              console.log('after...', updatedArray[selectedRoomIndex]);
              return updatedArray;
            });
          }
        } else {
          console.error("Request failed:", error.message);
        }
      });;

    } catch (err) {
      console.error("Error fetching options:", err);
      setError("Failed to fetch options. Try again.");
    } finally {
      setLoading(false);
    }

  };



  const fetchOptions = async () => {
    setRooms([]);
    setLoading(true);
    setError(null);
    console.log('selectedDateFormat................', selectedDate);

    try {
      const response = await axios.get(apiUrl + `discover`, {
        params: { office_id: selectedOffice, floor: selectedFloor, date: selectedDate, to: "", search: "", category: selectedCategory },
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          "Accept": "application/json",

          "Access-Control-Allow-Origin": "*", // Required for CORS support to work
          "Authorization": getCookie("mawalog")
        }
      }).then(async (response) => {
        setRooms([])
        if (response.data.success === true) {
          if (response.data.rooms.length > 0) {
            for (const meeting of response.data.rooms) {

              setRooms((prevRooms) => {
                meeting["slot_range"] = "30 mins";
                meeting["start_time"] = "";
                meeting["start_time_12hr"] = "";
                meeting["end_time"] = "";
                meeting["end_time_12hr"] = "";

                prevRooms.push(meeting);
                return prevRooms;
              });


            }

            const bookIds = response.data.rooms.map((item) => item.id);

            const data = {
              "office_id": selectedOffice,
              "floor": selectedFloor,
              "date": selectedDate,
              "from": "",
              "to": "",
              "id": bookIds,
              "range": ""
            };

            const headers = {
              'Content-Type': 'application/json;',
              "Accept": "application/json",
              "Access-Control-Allow-Origin": "*",
              "Authorization": getCookie("mawalog")
            };
            const response2 = await axios.post(apiUrl + "get_slots",
              data,
              { headers: headers }
            ).then(async (response2) => {
              if (response2.statusCode === 400) {
              } else {
                if (response2.data.success === true) {
                  var slotIndex = -1;
                  if (response2.data.data.length > 0) {
                    const now = new Date();
                    const hours = now.getHours().toString().padStart(2, '0');
                    const minutes = now.getMinutes().toString().padStart(2, '0');
                    /* for (const [index, slot] of response2.data.data[0]["slots"]) {
                      const isCurrentTime=  compareTimes(`${hours}:${minutes}`,slot["from"]); 
                      if (isCurrentTime === true) {                              
                        break; // Exit the loop
                      }
                      
                    } */
                    response2.data.data[0]["slots"].some((slot, index) => {
                      console.log('current time.....', `${hours}:${minutes}`)
                      console.log('slot time.....', slot["from"])
                      const isCurrentTime = compareTimes(slot["from"], slot["to"], `${hours}:${minutes}`);
                      console.log('isCurrentTime.....', isCurrentTime)
                      if (isCurrentTime === true) {
                        slotIndex = index;
                        return true; // Exit the loop
                      }
                      return false;
                    });

                  }
                  console.log('slot index....', slotIndex);
                  response2.data.data.forEach((roomobj) => {
                    /*  for (var roomobj in response2.data.data) { */

                    const index = response.data.rooms
                      .findIndex(element => element.id === roomobj["id"]);
                    console.log(index);
                    if (index > -1) {
                      /*  meetingList[index]["slots"] = room["slots"]; */
                      setRooms((prevRooms) => {
                        const updatedArray = [...prevRooms];
                        if (updatedArray[index] !== undefined) {
                          updatedArray[index]["slots"] = roomobj["slots"];
                        }
                        return updatedArray;
                      });
                      console.log('ref slotIndex', slotIndex)
                      console.log('ref Index', index)
                      const ref = scrollRefs.current[index];
                      if (ref) {
                        console.log('ref exist')
                        ref.scrollBy({ left: 126 * slotIndex, behavior: "smooth" });
                      }

                    }
                  });
                  await new Promise((resolve) =>
                    setTimeout(() => resolve(), 1000)
                  );
                  response2.data.data.forEach((roomobj) => {
                    /*  for (var roomobj in response2.data.data) { */

                    const index = response.data.rooms
                      .findIndex(element => element.id === roomobj["id"]);
                    console.log(index);
                    if (index > -1) {
                      /*  meetingList[index]["slots"] = room["slots"]; */

                      console.log('ref slotIndex', slotIndex)
                      console.log('ref Index', index)
                      const ref = scrollRefs.current[index];
                      if (ref) {
                        console.log('ref exist')
                        ref.scrollBy({ left: (130 * slotIndex) + 126, behavior: "smooth" });
                      }

                    }
                  });

                }

              }
            });





          }
        }
      });








    } catch (err) {
      console.error("Error fetching options:", err);
      setError("Failed to fetch options. Try again.");
    } finally {
      setLoading(false);
    }
  };
  const getCategory = async () => {
    try {
      const response = await axios.get(apiUrl + `get_room_category?type=filter`, {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          "Accept": "application/json",

          "Access-Control-Allow-Origin": "*", // Required for CORS support to work
          "Authorization": getCookie("mawalog")
        }
      });

      // const data = await response.json();
      console.log("Room List:", roomList);
      console.log("Room List Length:", roomList.length);
      setCategory([]);
      response.data.suggestionlist.forEach((category) => {
        setCategory((prevCategory) => {
          prevCategory.push(category);
          console.log("Updated Room List:", category); // Check updated roomList
          console.log("Updated Room roomList List:", categoryList);

          return prevCategory;
        });
      });
    } catch (err) {
      console.error("Error fetching category:", err);
      setError("Failed to fetch category. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const getFloor = async (roomId) => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(apiUrl + `get_floors/${roomId === '' ? '0' : roomId}`, {
        params: { type: 'filter', term: '' },
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          "Accept": "application/json",

          "Access-Control-Allow-Origin": "*", // Required for CORS support to work
          "Authorization": getCookie("mawalog")
        }
      });

      // const data = await response.json();
      setFloors([]);
      setFloors(response.data.suggestionlist);
    } catch (err) {
      console.error("Error fetching floors:", err);
      setError("Failed to fetch floors. Try again.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    // Attach event listener to the document
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Clean up event listener on unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    console.log("State updated:", roomList.length);
  }, [roomList]);

  function convertTo12HourFormat(time24) {
    // Split the time string into hours and minutes
    const [hours24, minutes] = time24.split(":");

    // Convert to a number and calculate 12-hour format
    const hours = parseInt(hours24, 10) % 12 || 12; // Convert 0 to 12 for midnight
    const period = parseInt(hours24, 10) >= 12 ? "PM" : "AM";

    // Return formatted time
    return `${hours}:${minutes} ${period}`;
  }

  const compareTimes = (fromTime, toTime, currentTime) => {
    // Split the times into hours and minutes
    const [hours1, minutes1] = fromTime.split(':').map(Number);
    const [hours2, minutes2] = toTime.split(':').map(Number);
    const [hours3, minutes3] = currentTime.split(':').map(Number);

    // Convert both times to total minutes
    const totalFromMinutes = (hours1 * 60) + minutes1;
    const totalToMinutes = (hours2 * 60) + minutes2;
    const totalCurrentMinutes = (hours3 * 60) + minutes3;
    // Compare the total minutes
    if (totalFromMinutes < totalCurrentMinutes && totalToMinutes > totalCurrentMinutes) {
      return true;
    } else {
      return false;
    }
  };
  const [bookingDetails, setBookingDetails] = useState(null);
  const bookedStatus = (bookingSlot) => {
    console.log(bookingSlot)
  }
  const getBookedStatus = async (roomId, bookingSlot) => {
    console.log(bookingSlot)
    setShowModal(false);
    try {
      const result = await handleBookingStatus(roomId, selectedDate, bookingSlot); // Wait for API response
      if (result.success === true) {
        setBookingDetails(result.details);
        setShowModal(true);
      }
      // Update state
    } catch (error) {
      console.error('Error adding item:', error);
    }
    console.log("Successfully called");

    /*  const datas = {
       "date": "2025-02-19",
       "room_id": roomId,
       "from": slot.from,
       "to": slot.to
     };
   
     const headers = {
       'Content-Type': 'application/json',
       "Accept": "application/json",
       "Access-Control-Allow-Origin": "*",
       "Authorization": getCookie("mawalog")
     };
   
     try {
       const response = await axios.post(apiUrl + "get_booking_details", datas, { headers });
       console.log("Response:", response.data);
       return response.data; // Returning the response data
     } catch (error) {
       console.error("Error fetching booking details:", error);
     } */
  };

  function checkFloorRadioChecked(selectedValue) {
    console.log('selectedValue', selectedValue)
    console.log('selectedFloor', selectedFloor)
    console.log('checked radio...', selectedFloor === selectedValue ? true : false)
    return selectedFloor === selectedValue ? true : false;
  }
  return (<Container fluid className="DiscoverContainer GTWalsheimTrial px-0">
    <div>
      {showModal && <DiscoverModal bookingData={bookingDetails} show={showModal} onHide={() => { setShowModal(false); setBookingDetails(null); }} />}
    </div>
    <div>
      {showRepeatBookingModal && <RepeatBookingModal roomId={selectedRoomId} show={showRepeatBookingModal} onHide={() => setShowRepeatBookingModal(false)} />}
    </div>
    <BottomSheet open={openFilter} snapPoints={({ maxHeight }) => maxHeight - 80}> <div style={{ padding: '16px', background: '#ffffff' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', }}>
        <div style={filterTitle} >
          Filter
        </div>
        <FilterCloseMobileIcon onClick={() => { setOpenFilter(false) }} />
      </div>
      <div style={officeTitle} >
        Office
      </div>
      <SearchWithAPI onDropdownChange={handleDropdownChange} apiUrl={apiUrl + `get_office`} placeholder={"Select an option"} selectedValue={selectedOffice} selectedOption={selectedOfficeOption} />
      {floorList.length > 0 && (<div style={officeTitle} >
        Floor
      </div>)}
      <div style={{ maxHeight: '200px', overflowY: 'scroll' }}>
        {floorList.map((item, roomIndex) => (
          <div key={`${roomIndex}-room-bottom`} style={{ height: '36px', marginLeft: '8px', marginRight: '8px', paddingLeft: '8px', paddingRight: '8px', display: 'flex', justifyContent: "start", alignItems: "center", }}>
            <label key={'radio-btn-bottom-' + item['value']} style={{ fontSize: "13.5px", fontWeight: "500", color: '#1E1E1E', display: 'flex', justifyContent: "start", alignItems: "center", }}>
              <input key={'radio-btn-' + item['value']}
                type="radio"
                name={`${item['value']}-floor-bottom`}
                value={item['value']}
                checked={checkFloorRadioChecked(item['value'].toString())}
                onChange={(event) => {
                  console.log(event.target.value);
                  setFloorValue(event.target.value.toString());
                }}
              />
              &nbsp;&nbsp;
              {item['label']}
            </label>


          </div>
        ))}
      </div>


      <div style={officeTitle} >
        Date
      </div>
      <input id="selected_date"
        type="date" value={selectedDate} onChange={(event) => { setSelectedDate(event.target.value); }}
        style={{
          height: "40px",
          borderRadius: "10px",
          border: "0.7px solid #E5E5E5",
          padding: "16px",
        }}
        class="date-picker w-100"
        placeholder="DD-MM-YYYY"
      />
      {/*  <div style={{ position: 'relative', height: "40px" }}>
        
        <div style={{ display: 'flex', alignItems: 'center', border: '0.7px solid #E5E5E5', borderRadius: '8px', padding: '10px 12px' }}>
          <input
            type="text"
            value={selectedDate ? formatDate(selectedDate.toLocaleDateString()) : ''}
            onClick={() => setShowPicker(!showPicker)}
            readOnly
            style={{ flex: 1, border: 'none', outline: 'none', cursor: 'pointer' }}
            placeholder="Select a date"
          />
          <CalendarIcon style={{ cursor: 'pointer', color: '#842234' }} onClick={() => setShowPicker(!showPicker)} />
          
        </div>

       
        {showPicker && (
          <div style={{ position: 'absolute', top: '40px', zIndex: 100, background: '#fff', border: '1px solid #ccc', borderRadius: '4px', boxShadow: '0px 4px 6px rgba(0,0,0,0.1)' }}>
            <DayPicker mode="single" selected={selectedDate} onSelect={handleDateChange} />
          </div>
        )}
      </div> */}
      &nbsp;&nbsp;
      <Row style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: '8px' }}>
        <div onClick={(e) => {
          handleReset();
          // setSelectedOfficeOption(null);
          // setOfficeValue('');
          // setFloorValue('');
          // setFloors([]);
          // setSelectedDate(moment(today).format("YYYY-MM-DD"));
          // fetchOptions();
        }} style={{ width: '176px', height: '44px', marginLeft: '8px', marginRight: '8px', borderRadius: '100px', display: 'flex', justifyContent: "center", alignItems: "center", backgroundColor: '#FFFFFF', border: '0.6px solid #E5E5E5', }}>
          <div style={{ fontSize: "14px", fontWeight: "700", color: '#1E1E1E' }}>Reset Filter1</div>
        </div>
        <div onClick={() => { setOpenFilter(false) }} style={{ width: '176px', height: '44px', marginLeft: '8px', marginRight: '8px', borderRadius: '100px', display: 'flex', justifyContent: "center", alignItems: "center", backgroundColor: '#842234', }}>
          <div style={{ fontSize: "14px", fontWeight: "700", color: '#FFFFFF' }}>Apply</div>
        </div>
      </Row>
      <div style={{ height: '250px' }}></div>
    </div></BottomSheet>



    <Row className="px-3" style={{ height: 'calc(100vh - 68px)', }}>
      <Col lg={3} xxl={2} className="d-none d-lg-block" style={{ padding: '16px', background: '#ffffff', borderRight: '1px solid #E5E5E5' }}>
        <div >
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', }}>
            <div style={filterTitle} >
              Filter
            </div>
            <div onClick={() => {
              handleReset();
            }} style={{ cursor: "pointer", height: '28px', paddingLeft: '8px', paddingRight: '8px', borderRadius: '45px', display: 'flex', justifyContent: "center", alignItems: "center", backgroundColor: '#FFF2F5' }}>
              <FilterCloseIcon /> <div style={{ paddingLeft: '4px', fontSize: "13px", fontWeight: "400", color: '#842234' }}>Reset filter</div>
            </div>
          </div>
          <div style={officeTitle} >
            Office
          </div>
          <SearchWithAPI onDropdownChange={handleDropdownChange} apiUrl={apiUrl + `get_office`} placeholder={"Select an option"} selectedOption={selectedOfficeOption} />
          {floorList.length > 0 && (<div style={officeTitle} >
            Floor
          </div>)}
          <div style={{ maxHeight: '200px', overflowY: 'scroll' }}>
            {floorList.map((item, roomIndex) => (
              <div key={`${roomIndex}-room`} style={{ height: '36px', marginLeft: '8px', marginRight: '8px', paddingLeft: '8px', paddingRight: '8px', display: 'flex', justifyContent: "start", alignItems: "center", }}>
                <label style={{ fontSize: "13.5px", fontWeight: "500", color: '#1E1E1E', display: 'flex', justifyContent: "start", alignItems: "center", }}>
                  <input key={item['value']}
                    type="radio"
                    name={`${item['value']}-floor`}
                    value={item['value']}
                    checked={selectedFloor === item['value'].toString() ? true : false}
                    onChange={(event) => {
                      console.log(selectedFloor);
                      console.log(event.target.value);
                      setFloorValue(event.target.value);

                    }}
                  />
                  &nbsp;&nbsp;
                  {item['label']}
                </label>


              </div>
            ))}
          </div>


          <div style={officeTitle} >
            Date
          </div>
          <input id="selected_date"
            type="date" value={selectedDate} onChange={(event) => { setSelectedDate(event.target.value); }}
            style={{
              height: "40px",
              borderRadius: "10px",
              border: "0.7px solid #E5E5E5",
              padding: "16px",
            }}
            class="date-picker w-100"
            placeholder="DD-MM-YYYY"
          />
          {/*  <DayPicker
      mode="single"
      selected={selectedDate}
      onSelect={setSelectedDate}
      footer={footer}
    /> */}
          {/*  <div style={{ position: 'relative', height: "40px" }}>
            
            <div style={{ display: 'flex', alignItems: 'center', border: '0.7px solid #E5E5E5', borderRadius: '8px', padding: '10px 12px' }}>
              <input
                type="text"
                value={selectedDate ? formatDate(selectedDate.toLocaleDateString()) : ''}
                onClick={() => setShowPicker(!showPicker)}
                readOnly
                style={{ flex: 1, border: 'none', outline: 'none', cursor: 'pointer' }}
                placeholder="Select a date"
              />
              <CalendarIcon style={{ cursor: 'pointer', color: '#842234' }} onClick={() => setShowPicker(!showPicker)} />
            </div>

            {showPicker && (
              <div style={{ position: 'absolute', top: '40px', zIndex: 100, background: '#fff', border: '1px solid #ccc', borderRadius: '4px', boxShadow: '0px 4px 6px rgba(0,0,0,0.1)' }}>
                <DayPicker mode="single" selected={selectedDate} onSelect={handleDateChange} />
              </div>
            )}
          </div> */}


        </div>
      </Col>
      <Col sm={12} lg={9} xxl={10} style={{ padding: '16px', background: '#ffffff' }}>

        <div style={title} >
          Book Meeting Rooms
        </div>
        &nbsp;&nbsp;
        <div style={subtitle} >
          Select & book meeting rooms for a meetings & send calendar invites accordingly
        </div>
        &nbsp;&nbsp;
        <Row>
          <div style={{ display: 'flex', overflow: 'auto', }}>
            {categoryList.map((item, categoryIndex) => (<div key={`${categoryIndex}-category`}>
              <div onClick={() => handleCategoryClick(item['value'])} style={{ width: '160px', cursor: "pointer", height: '36px', marginLeft: '8px', marginRight: '8px', marginBottom: '4px', paddingLeft: '8px', paddingRight: '8px', borderRadius: '8px', display: 'flex', justifyContent: "center", alignItems: "center", backgroundColor: selectedCategory === item['value'] ? '#FFF2F5' : '#F9F9F9', }}>
                <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: "14px", fontWeight: "400", color: selectedCategory === item['value'] ? '#842234' : '#1E1E1E', opacity: selectedCategory === item['value'] ? '1' : '0.8' }}>{item['label']}</div>
              </div>
            </div>
            ))}

          </div>
        </Row>

        &nbsp;
        <Row className="d-lg-none">
          <Col xs={10} sm={11} >
            <Form >

              <Form.Group style={{ borderRadius: "100px", border: '0.6px solid #E5E5E5', overflow: 'hidden' }}>

                <InputGroup >

                  <Button variant="outline-secondary" style={{ backgroundColor: '#ffffff', border: 'none', outline: 'none', boxShadow: 'none' }}>
                    <SearchIcon />
                  </Button>
                  <Form.Control

                    className="custom-input"
                    type="text"
                    placeholder="Search..."
                    value={searchInputValue}
                    onChange={(event) => {
                      setSearchInputValue(event.target.value);


                    }}
                    style={{ border: 'none', outline: 'none', boxShadow: 'none' }}
                  />

                </InputGroup>
              </Form.Group>
            </Form>
          </Col>
          <Col xs={2} sm={1}>
            <FilterIcon onClick={() => { setOpenFilter(!openFilter) }} style={{ cursor: "pointer", }} />
          </Col>
        </Row>

        &nbsp;
        <Row >
          <Col xs={12} style={{ height: 'calc(100vh - 320px)', overflow: 'auto', scrollbarWidth: "none", msOverflowStyle: "none", }}>
            {roomList.map((item, roomIndex) => (
              <Row key={`${roomIndex}-room`} style={{ paddingTop: '24px', paddingBottom: '24px', display: 'flex', justifyContent: "start", alignItems: "center", }}>
                {/* <Row md={12} className="justify-content-between"> */}

                <Col xs={12} lg={6} xl={7} onClick={() => { navigate("/discover-view", { state: { id: item["id"], date: selectedDate, formatted_date: commonFormatDate(selectedDate, "dddd, DD MMM YYYY"), } }); }} /* className="justify-content-start justify-content-sm-center" */ style={{ cursor: "pointer", display: 'flex', }}>
                  {/*  <div style={{display: 'flex',}}> */}
                  <img src={item['image'] != null && item['image'] !== '' ? item['image'] : RoomImage} alt="room" style={{ width: '140px', height: '140px', borderRadius: '12px' }} />&nbsp;&nbsp;
                  <div>
                    <div style={roomTitle} >
                      {item["room"]}
                    </div>

                    <div style={seatCount} >
                      {item["capacity"]} Seater
                    </div>
                    &nbsp;&nbsp;
                    <div style={availableTitle} >
                      Available :
                    </div>

                    <Col lg={6} style={{ display: 'flex', flexWrap: 'wrap', }}>
                      {item["available"] != null && item["available"].split(",").map((available, index) => (
                        <div key={`${index}-available`} style={{ height: '24px', marginRight: '6px', marginBottom: '4px', paddingLeft: '8px', paddingRight: '8px', borderRadius: '8px', display: 'flex', justifyContent: "center", alignItems: "center", backgroundColor: '#F5F7F9' }}>
                          <div style={availableName}>{available}</div>
                        </div>
                      ))}
                    </Col>
                  </div>
                  {/*  </div> */}
                </Col>
                <Col xs={12} lg={6} xl={4} className="justify-content-start justify-content-sm-start justify-content-md-end" >

                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', }}>
                    <div style={slotTitle}>Select your slot </div>
                    <div key={`${roomIndex}-more`} style={{ position: "relative" }}>
                      <div onClick={() => { setAlertIndex(roomIndex === alertIndex ? null : roomIndex); }} /*  onClick={() =>openModal(item["id"],roomIndex)} */ style={{ cursor: "pointer", width: '79px', height: '28px', borderRadius: '62px', border: '0.8px solid #842234', display: 'flex', justifyContent: "center", alignItems: "center", backgroundColor: '#FFFFFF' }}>
                        <div style={slotTitleSelected}>{item['slot_range']}</div>&nbsp; <div><ArrowDownIcon /></div>
                      </div>


                      {alertIndex === roomIndex && (
                        <div ref={alertRef} style={{
                          position: "absolute",
                          top: "40px",
                          left: "0%",
                          transform: "translateX(-50%)",
                          backgroundColor: "#ffffff",
                          color: "#1E1E1E",
                          padding: "16px",
                          borderRadius: "16px",
                          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                          zIndex: 1, alignItems: 'end',
                        }}>
                          <div style={{ cursor: "pointer", width: '150px', height: '36px', fontSize: "14px", fontWeight: "500", color: '#1E1E1E', display: 'flex', alignItems: 'center', justifyContent: 'start' }}
                            onClick={async () => {
                              setRoomId(roomList[roomIndex]["id"]);
                              setRooms((prevRooms) => {
                                const updatedArray = [...prevRooms];
                                if (updatedArray[roomIndex] !== undefined) {
                                  updatedArray[roomIndex]["slot_range"] = "30 mins";
                                }
                                return updatedArray;
                              });
                              setAlertIndex(null);
                              await new Promise((resolve) =>
                                setTimeout(() => resolve(), 500)
                              );
                              setSlotValue("30 mins");
                            }}>
                            30 mins slot
                          </div>
                          <div style={{ cursor: "pointer", width: '150px', height: '36px', fontSize: "14px", fontWeight: "500", color: '#1E1E1E', display: 'flex', alignItems: 'center', justifyContent: 'start' }}
                            onClick={async () => {
                              setRoomId(roomList[roomIndex]["id"]);

                              setRooms((prevRooms) => {
                                const updatedArray = [...prevRooms];
                                if (updatedArray[roomIndex] !== undefined) {
                                  updatedArray[roomIndex]["slot_range"] = "1 hour";
                                }
                                return updatedArray;
                              });

                              setAlertIndex(null);
                              await new Promise((resolve) =>
                                setTimeout(() => resolve(), 500)
                              );
                              setSlotValue("1 hour");
                            }}>
                            One hour slot
                          </div>
                          <div style={{ cursor: "pointer", width: '150px', height: '36px', fontSize: "14px", fontWeight: "500", color: '#1E1E1E', display: 'flex', alignItems: 'center', justifyContent: 'start' }}
                            onClick={() => {
                              setRoomId(roomList[roomIndex]["id"]);

                              setRooms((prevRooms) => {
                                const updatedArray = [...prevRooms];
                                if (updatedArray[roomIndex] !== undefined) {
                                  updatedArray[roomIndex]["slot_range"] = "custom";
                                }
                                return updatedArray;
                              });
                              setAlertIndex(null);
                              setSlotValue("custom");
                            }} >
                            Customized time
                          </div>

                          <div style={{ cursor: "pointer", width: '150px', height: '36px', fontSize: "14px", fontWeight: "500", color: '#1E1E1E', display: 'flex', alignItems: 'center', justifyContent: 'start' }}
                            onClick={() => {
                              setRoomId(roomList[roomIndex]["id"]);

                              /* setRooms((prevRooms) => {
                                const updatedArray = [...prevRooms];
                                if (updatedArray[roomIndex] !== undefined) {
                                  updatedArray[roomIndex]["slot_range"] = "custom";
                                }
                                return updatedArray;
                              });
                              setAlertIndex(null);
                              setSlotValue("custom"); */
                              setShowRepeatBookingModal(true);
                            }} >
                            Repeat
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  {item['slot_range'] !== 'custom' && (<Row style={{ display: 'flex', marginTop: '8px', alignItems: 'center', justifyContent: 'space-between', }}>
                    <Col xs={1} lg={2} xl={1} key={`${roomIndex}-arrow-btn-1`} style={{ display: 'flex', alignItems: 'center', height: '40px', justifyContent: "end", }}>
                      <div style={{ cursor: "pointer", width: '28px', height: '28px', }}> <div onClick={() => scrollLeft(roomIndex)} style={{ width: '28px', height: '28px', borderRadius: '100px', border: '0.5px solid #D4DDE7', display: 'flex', justifyContent: "center", alignItems: "center", backgroundColor: '#FFFFFF', color: '#842234' }}>
                        <div><ArrowPrevIcon /></div>
                      </div></div>
                    </Col>
                    <Col xs={10} lg={8} xl={10} key={roomIndex} ref={(el) => (scrollRefs.current[roomIndex] = el)} style={{ paddingLeft: '8px', display: 'flex', justifyContent: "start", alignItems: "center", whiteSpace: "nowrap", height: '40px', overflowX: "scroll", overflowY: "hidden", scrollbarWidth: "none", msOverflowStyle: "none", }}>

                      {item["slots"] != null && item["slots"].map((slot, slotIndex) => (
                        <div onClick={() => {
                          console.log(slot);
                          if (slot["expired"] === false && slot["available"] === true) {
                            setRooms((prevRooms) => {
                              const updatedArray = [...prevRooms];
                              if (updatedArray[roomIndex] !== undefined) {
                                updatedArray[roomIndex]["selected_slot"] = slot["period"];
                                updatedArray[roomIndex]["selected_slot_from"] = slot["from"];
                                updatedArray[roomIndex]["selected_slot_to"] = slot["to"];
                              }
                              return updatedArray;
                            });
                          } else {
                            /* console.log(slot) */
                            if (slot["id"] !== 0) {
                              getBookedStatus(item["id"], slot);

                            }


                          }
                        }} key={`${roomIndex}-${slotIndex}`} style={{/* width: '120px', */ cursor: "pointer", height: '32px', marginRight: '6px', marginBottom: '4px', paddingLeft: '8px', paddingRight: '8px', borderRadius: '8px', display: 'flex', justifyContent: "center", alignItems: "center",
                          backgroundColor: slot["expired"] === true
                            ? '#F5F5F5'
                            : (slot["available"] === false
                              ? '#FFF1F4'
                              : (item["selected_slot"] === slot["period"]
                                ? '#EDFFF5'
                                : '#FFFFFF')),

                          border: slot["expired"] === true
                            ? '1px solid #E5E5E5'
                            : (slot["available"] === false
                              ? '1px solid #E93153'
                              : (item["selected_slot"] === slot["period"]
                                ? '1px solid #20824A'
                                : '1px solid #E5E5E5')),

                        }}>
                          <div
                            style={{
                              fontSize: "12.5px",
                              fontWeight: "400",
                              color: slot["expired"] === true
                                ? '#1E1E1E'
                                : (slot["available"] === false
                                  ? '#842234'
                                  : '#000000'
                                )
                            }}
                          >
                            {slot["period"]}
                          </div>
                        </div>

                        //hi
                      ))}
                    </Col>
                    <Col xs={1} lg={2} xl={1} key={`${roomIndex}-arrow-btn-2`} style={{ display: 'flex', alignItems: 'center', height: '40px', justifyContent: "start", }}>
                      <div style={{ cursor: "pointer", width: '28px', height: '28px', }}>
                        <div onClick={() => scrollRight(roomIndex)} style={{ width: '28px', height: '28px', borderRadius: '100px', border: '0.5px solid #D4DDE7', display: 'flex', justifyContent: "center", alignItems: "center", backgroundColor: '#FFFFFF', color: '#842234' }}>
                          <div><ArrowNextIcon /></div>
                        </div>
                      </div>
                    </Col>
                  </Row>)}

                  {item['slot_range'] === 'custom' && (
                    <Row>
                      <Col>
                        <div className="material-form-group">
                          <input
                            type="time"
                            id="material-input"
                            className="form-control material-input"
                            placeholder=" "
                            value={item["start_time"]}
                            onChange={(event) => {
                              setRoomIndex(roomIndex);
                              setRooms((prevRooms) => {
                                const updatedArray = [...prevRooms];
                                if (updatedArray[roomIndex] !== undefined) {
                                  updatedArray[roomIndex]["start_time"] = event.target.value;
                                  updatedArray[roomIndex]["start_time_12hr"] = convertTo12HourFormat(event.target.value);
                                  if (updatedArray[roomIndex]["end_time"] !== "") {
                                    getCustomSlots(event.target.value, updatedArray[roomIndex]["end_time"]);
                                  }
                                }
                                return updatedArray;
                              });


                            }}
                          />
                          <label htmlFor="material-input" className="material-label">
                            Start Time
                          </label>
                        </div>
                        {/*  { customSlotErrorMessage.from!=="" && (<Form.Text  style={{textAlign:'start',}} className="text-muted" >
                                 <div style={{color:'#ff0000'}}>{customSlotErrorMessage.from}</div>
                                  </Form.Text>)} 
                                  { errorMessage!=="" && ( <div style={{ fontSize:"14px", fontWeight:"700", color: '#FF4444' }}> {errorMessage}  </div>)} */}
                      </Col>
                      <Col>
                        <div className="material-form-group">
                          <input
                            type="time"
                            id="material-input"
                            className="form-control material-input"
                            placeholder=" "
                            value={item["end_time"]}
                            onChange={(event) => {
                              console.log('selected end time....', event.target.value);
                              setRoomIndex(roomIndex);
                              setRooms((prevRooms) => {
                                const updatedArray = [...prevRooms];
                                if (updatedArray[roomIndex] !== undefined) {
                                  updatedArray[roomIndex]["end_time"] = event.target.value;
                                  updatedArray[roomIndex]["end_time_12hr"] = convertTo12HourFormat(event.target.value);
                                  if (updatedArray[roomIndex]["start_time"] !== "") {
                                    getCustomSlots(updatedArray[roomIndex]["start_time"], event.target.value);
                                  }
                                }
                                return updatedArray;
                              });
                              setRoomIndex(roomIndex);

                            }}
                          />
                          <label htmlFor="material-input" className="material-label">
                            End Time
                          </label>
                        </div>
                        {/*  { customSlotErrorMessage.to!=="" && (<Form.Text  style={{textAlign:'start',}} className="text-muted" >
                                 <div style={{color:'#ff0000'}}>{customSlotErrorMessage.to}</div>
                                  </Form.Text>)}  */}
                      </Col>
                    </Row>
                  )}
                  {roomList[roomIndex]["error_message"] !== null && roomList[roomIndex]["error_message"] !== "" && (<div style={{ fontSize: "14px", fontWeight: "700", color: '#FF4444' }}> {roomList[roomIndex]["error_message"]}  </div>)}
                  <div onClick={() => {
                    if (roomList[roomIndex]["selected_slot"] !== undefined && roomList[roomIndex]["selected_slot"] !== "") {
                      navigate("/book-meeting", { state: { id: item["id"], date: moment(selectedDate).format("YYYY-MM-DD"), formatted_date: commonFormatDate(selectedDate, "dddd, DD MMM YYYY"), selected_slot: item["selected_slot"], selected_slot_from: item["selected_slot_from"], selected_slot_to: item["selected_slot_to"], } });
                    }
                  }} style={{ cursor: "pointer", height: '36px', marginTop: '8px', borderRadius: '12px', display: 'flex', justifyContent: "center", alignItems: "center", backgroundColor: '#842234', opacity: roomList[roomIndex]["selected_slot"] !== undefined && roomList[roomIndex]["selected_slot"] !== "" ? 1 : 0.7 }}>
                    <div style={{ fontSize: "14px", fontWeight: "700", color: '#F3F6F9', }}>Book Slot</div>
                  </div>
                  {isOpen && (

                    <div style={modalStyle.overlay}>
                      <div style={modalStyle.modal}>
                        <div  >
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', }}>
                              <SlotFilterIcon /><div style={{ paddingLeft: '4px', fontSize: "20px", fontWeight: "700", color: '#1E1E1E' }}>Change Slot Type</div>
                            </div>
                            <SlotCloseIcon onClick={closeModal} />
                          </div>
                          <div style={{ marginTop: '20px', }}>
                            <div onClick={() => {
                              console.log(selectedSlot);

                              setSlotValue("30 mins");
                              setRooms((prevRooms) => {
                                const updatedArray = [...prevRooms];
                                if (updatedArray[selectedRoomIndex] !== undefined) {
                                  updatedArray[selectedRoomIndex]["slot_range"] = "30 mins";
                                }
                                return updatedArray;
                              });

                              closeModal();
                            }} style={{ height: '46px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', }}>
                              <div style={{ paddingLeft: '4px', fontSize: "20px", fontWeight: "700", color: '#1E1E1E' }} className="custom-radio">
                                30 mins slot
                              </div>
                              <label>
                                <input key="30mins"
                                  type="radio"
                                  name="30mins"
                                  value="30 mins"
                                  checked={roomList[selectedRoomIndex]["slot_range"] === "30 mins" ? true : false}
                                /*  onChange={(event) => {
                                   console.log(selectedSlot);
                                   console.log(event.target.value);
                                   setSlotValue(event.target.value);
                                 }} */
                                />
                              </label>

                            </div>

                            <div onClick={() => {
                              console.log(selectedSlot);

                              setSlotValue("1 hour");
                              setRooms((prevRooms) => {
                                const updatedArray = [...prevRooms];
                                if (updatedArray[selectedRoomIndex] !== undefined) {
                                  updatedArray[selectedRoomIndex]["slot_range"] = "1 hour";
                                }
                                return updatedArray;
                              });

                              closeModal();
                            }} style={{ height: '46px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', }}>
                              <div style={{ paddingLeft: '4px', fontSize: "20px", fontWeight: "700", color: '#1E1E1E' }} className="custom-radio">
                                One hour slot
                              </div>

                              <label>
                                <input key="1hourradio"
                                  type="radio"
                                  name="1hourradio"
                                  value="1 hour"
                                  checked={roomList[selectedRoomIndex]["slot_range"] === "1 hour" ? true : false}
                                /*  onChange={(event) => {
                                   console.log(selectedSlot);
                                   console.log(event.target.value);
                                   setSlotValue(event.target.value);
                                 }} */
                                />
                              </label>
                            </div>

                            <div onClick={() => {
                              console.log(selectedSlot);

                              setSlotValue("custom");
                              setRooms((prevRooms) => {
                                const updatedArray = [...prevRooms];
                                if (updatedArray[selectedRoomIndex] !== undefined) {
                                  updatedArray[selectedRoomIndex]["slot_range"] = "custom";
                                }
                                return updatedArray;
                              });
                              closeModal();
                            }} style={{ height: '46px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', }}>
                              <div style={{ paddingLeft: '4px', fontSize: "20px", fontWeight: "700", color: '#1E1E1E' }} className="custom-radio">
                                Customized time
                              </div>

                              <label>
                                <input key="customradio"
                                  type="radio"
                                  name="customradio"
                                  value="custom"
                                  checked={roomList[selectedRoomIndex]["slot_range"] === "custom" ? true : false}
                                /*  onChange={(event) => {
                                   console.log(selectedSlot);
                                   console.log(event.target.value);
                                   setSlotValue(event.target.value);
                                 }} */
                                />
                              </label>
                            </div>


                          </div>
                        </div>
                      </div>
                    </div>

                  )}

                </Col>
                {/* </Row> */}
              </Row >
            ))}
            {roomList.length === 0 && (<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
              <NoRecordsFound />
              <div style={{ marginTop: '8px', fontSize: "16px", fontWeight: "500", color: '#212129', }}>No records found</div>
              <div style={{ fontSize: "13px", fontWeight: "400", color: '#8790A1', }}>Looks like you haven’t any data to show</div>
            </div>)}
          </Col>
        </Row>
      </Col>
    </Row>
    <LoaderModal show={loading} />

  </Container>)



}